<template>
	<div>
		<GenericSelector 
			:value="value"
			@input="val => $emit('input', value)"
			:options="options" 
            displayKey="path"
			:showOptions="showOptions"
			:canEdit="showOptions"
			:loading="loading || loadingOptions"
            @click="val => $emit('selectItem', value)"
		>
           <!--template v-slot:selectedHeader>
            <div class="list-group-item align-items-center">
                <div class="row">
                    <div class="col-10">
                        <div class="form-inline">
                            <template v-for="(option,x) in getOptions">
                                <SelectInput
                                    :key="x"
                                    v-if="displayInput(x) "
                                    v-model="node_query[x]"
                                    :nullable="true"
                                    :nullLabel="x==0 ? $t('root') : $t('child-n',{n : x})"
                                    :options="option"
                                    :label="x==0 ? $t('root') : $t('child-n',{n : x})"
                                    :srOnly="true"
                                    class="ml-2  align-items-center"
                                />

                            </template>
                            <TextInput
                                v-if="loaded"
                                v-model="node_query[Number(maxPath)]"
                                :nullable="true"
                                :nullLabel="$t('search')"
                                :label="$t('search')"
                                :srOnly="true"
                                class="ml-2"/>
                        </div>
                    </div>
                    <div class="col-2">
                            <div class="float-right">
                                <button v-if="node_query.length>0" class="btn btn-success ml-2 text-right" @click="node_query =[null]; hydrateNodeQuery()">{{ $t('clear') }}</button>
                            </div>
                    </div>
                </div>
            </div>
        </template-->
			<template v-slot:unselectedHeader>
				<div class="clearfix my-2">
					<SearchBar v-if="showOptions" v-model="search" :debounce="false" class="float-left" />
					<button 
						type="button" 
						@click="showOptions = !showOptions"
						class="btn float-right" 
						:class="showOptions ? 'btn-secondary' : 'btn-primary'"
                        v-if="canEdit"
					>
						<b-icon v-if="!showOptions" icon="plus" class="h6 mb-0 mr-1"/>{{ showOptions ? $t('done') : $t('edit') }}
					</button>
				</div>
			</template>
		</GenericSelector>
	</div>
</template>

<script>
import GenericSelector from '../Inputs/GenericSelector.vue';
import SearchBar from '../Table/SearchBar.vue';

export default {
	components: { 
		GenericSelector,
		SearchBar,
	},
    props: {
		value: Array,
		loading: {
			type: Boolean,
			default: false
		},
        canEdit: {
            type: Boolean,
            default: false
        },
        availableNodes: Array,
	},
    data() {
        return {
            showOptions: false,
			loadingOptions: false,
			search: '',
        };
    },
    mounted() {
    },
    methods: {
        displayInput(index){
            if (index === 0) {
                return true; // Always render the first SelectInput
            } else {
                return !!this.node_query[index - 1] && this.displayInput(index - 1); // Render if the previous v-model is non-empty
            } 
        },
    },
    computed: {
		options() {
            if(this.availableNodes){
                return this.availableNodes.filter(node => !this.search || node.path.toLowerCase().includes(this.search.toLowerCase()))
            } else {
                return [];
            }
		}
    },
};
</script>
